import { cookieConsents } from '#base/core/consts/cookieConsents';
import type { CookieConsentObjectType } from '#base/core/types/CookieConsentType';

export const getConsentObject = () => {
	const allConsents: CookieConsentObjectType = {};

	for (const cookieConsent of cookieConsents) {
		allConsents[cookieConsent.key] = 'on';

		if (cookieConsent.subCookieConsents) {
			for (const subCookieConsent of cookieConsent.subCookieConsents) {
				allConsents[subCookieConsent.key] = 'on';
			}
		}
	}

	return allConsents;
};

export const getConsentSetCookieKey = () => {
	let consentKeyCharacters = '';

	for (const cookieConsent of cookieConsents) {
		consentKeyCharacters += cookieConsent.key.charAt(0);

		if (cookieConsent.subCookieConsents) {
			for (const subCookieConsent of cookieConsent.subCookieConsents) {
				consentKeyCharacters += subCookieConsent.key.charAt(0);
			}
		}
	}

	return 'consent-set-' + consentKeyCharacters;
};
